var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card", attrs: { id: `id-${_vm.runner.id}` } }, [
      _c("div", { staticClass: "card-header" }, [
        _vm._v("\n      Рюкзак: "),
        _c("strong", [_vm._v(_vm._s(_vm.runner.name))]),
        _vm._v(
          " (id:" +
            _vm._s(_vm.runner.id) +
            ") выдан:\n      " +
            _vm._s(_vm.printDate(_vm.runner.back_pack.created_at)) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("table", { staticClass: "table table-hover" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { width: "65%" } }, [_vm._v("Препарат")]),
              _vm._v(" "),
              _vm.showBackPackOrders ? _c("th", [_vm._v("Заявки")]) : _vm._e(),
              _vm._v(" "),
              _c("th", [_vm._v("Закрытые заявки")]),
              _vm._v(" "),
              _c("th", [_vm._v("Количество")]),
              _vm._v(" "),
              _c("th", [_vm._v("Остаток")]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(
                _vm.orderedPrepNames(_vm.runner.back_pack.items),
                function (record, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      _vm._v(
                        "\n            " +
                          _vm._s(record.new_drug.title) +
                          " (" +
                          _vm._s(record.drug_id) +
                          ")\n            "
                      ),
                      record.qty < 0
                        ? _c("span", [
                            _vm._v(
                              "\n                Возврат (" +
                                _vm._s(Math.abs(record.qty)) +
                                ")"
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      record.new_drug.cool
                        ? _c("div", { staticClass: "pack_details" }, [
                            _c("i", { staticClass: "icon icon-snowflake" }),
                            _vm._v(" Требуется хладоген\n            "),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      record.new_drug.pack_comment
                        ? _c("div", { staticClass: "pack_details" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(record.new_drug.pack_comment) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      record.new_drug.pack_box_comment
                        ? _c(
                            "div",
                            { staticClass: "store_details text-muted" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(record.new_drug.pack_box_comment) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      record.orders && record.orders.length
                        ? _c(
                            "div",
                            { staticClass: "text-muted" },
                            [
                              _vm._l(record.orders, function (order) {
                                return [
                                  _vm.ordersData &&
                                  _vm.ordersData[order] &&
                                  _vm.ordersData[order].extra_options &&
                                  _vm.ordersData[order].extra_options
                                    .comments_for_runner
                                    ? _vm._l(
                                        _vm.ordersData[order].extra_options
                                          .comments_for_runner,
                                        function (comment) {
                                          return +comment.comment_type === 2
                                            ? _c("p", [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-dropbox",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(comment.text) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e()
                                        }
                                      )
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.showBackPackOrders
                      ? _c(
                          "td",
                          _vm._l(record.orders, function (order) {
                            return _c("p", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.mixinPrintOrderNum(order))),
                              ]),
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _vm.realisedDrugs &&
                        _vm.realisedDrugs[record.new_drug.id] &&
                        _vm.realisedDrugs[record.new_drug.id].orders.length
                          ? _vm._l(
                              _vm.realisedDrugs[record.new_drug.id].orders,
                              function (order) {
                                return _c("p", { key: order.id }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.mixinPrintOrderNum(order.id))
                                    ),
                                  ]),
                                  _vm._v(": "),
                                  _c(
                                    "span",
                                    { staticClass: "text-muted fs-11" },
                                    [_vm._v(_vm._s(order.report_date))]
                                  ),
                                ])
                              }
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "td",
                      [
                        record.qty < 0
                          ? [_vm._v("0")]
                          : [
                              +record.new_drug.pack_set !== 1
                                ? [
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            record.qty /
                                              record.new_drug.pack_set
                                          )
                                        ),
                                      ]),
                                      _vm._v(" компл."),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(_vm._s(record.qty)),
                                      ]),
                                      _vm._v(" зав.упак."),
                                    ]),
                                  ]
                                : [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(record.qty) +
                                        "\n              "
                                    ),
                                  ],
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        +record.new_drug.pack_set !== 1
                          ? [
                              _c("p", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getRemainingQty(
                                        record.qty,
                                        record.new_drug.id
                                      ) / record.new_drug.pack_set
                                    )
                                  ),
                                ]),
                                _vm._v("\n                компл.(а/ов)"),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getRemainingQty(
                                        record.qty,
                                        record.new_drug.id
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" зав.упак."),
                              ]),
                            ]
                          : [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.getRemainingQty(
                                      record.qty,
                                      record.new_drug.id
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ],
                      ],
                      2
                    ),
                  ])
                }
              ),
              _vm._v(" "),
              _vm._l(_vm.getOverItems(), function (item) {
                return _c("tr", { staticClass: "red" }, [
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(item.new_drug.title) +
                        " (" +
                        _vm._s(item.new_drug) +
                        ")\n            "
                    ),
                    item.new_drug.cool
                      ? _c("div", { staticClass: "pack_details" }, [
                          _c("i", { staticClass: "icon icon-snowflake" }),
                          _vm._v(" Требуется хладоген\n            "),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.new_drug.pack_comment
                      ? _c("div", { staticClass: "pack_details" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.new_drug.pack_comment) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.new_drug.pack_box_comment
                      ? _c("div", { staticClass: "store_details text-muted" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.new_drug.pack_box_comment) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.showBackPackOrders ? _c("td") : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "td",
                    _vm._l(item.orders, function (order) {
                      return _c("p", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.mixinPrintOrderNum(order.id))),
                        ]),
                        _vm._v(": "),
                        _c("span", { staticClass: "text-muted fs-11" }, [
                          _vm._v(_vm._s(order.report_date)),
                        ]),
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("td", [_vm._v("0")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("-" + _vm._s(item.qty))]),
                ])
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _vm.$currentRole != "storeKeeper"
          ? _c("div", { staticClass: "text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-warning",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.openModal(_vm.runner)
                    },
                  },
                },
                [_vm._v("\n          Обнулить рюкзак\n        ")]
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }